import { getHtmlStyle } from '../transfer';

const fold = {
  render(node, children) {
    const { props } = node;
    const { attrs, style } = props;

    const computeStyle = Object.assign({}, style);

    /**
     * expand: '0'-收起， '1'-展开
     */
    let expandClz = '';
    const { expand = '0' } = attrs;
    if (expand === '1') {
      expandClz = 'expand';
    }

    if (style.display === 'none') {
      computeStyle.display = 'none';
    }

    return `<div class="msg-xml-fold ${expandClz}" style="${getHtmlStyle(computeStyle)}">${children}</div>`;
  },
};

export default fold;
